"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddNewSongView = void 0;
const HTMLWidgetFormBuilder_1 = require("../core/render/HTMLWidgetFormBuilder");
const View_1 = require("../core/render/View");
const viewModelCollection_1 = require("../viewModelCollection");
const BrowseResourceModalDialogBox_1 = require("./modalDialogBoxes/BrowseResourceModalDialogBox");
const AccordionWidget_1 = require("./widgets/AccordionWidget");
const CardGridWidget_1 = require("./widgets/CardGridWidget");
const HtmlWidget_1 = require("./widgets/HtmlWidget");
const Resource_1 = require("../core/resourceSystem/Resource");
class AddNewSongView extends View_1.View {
    constructor(viewNavigator) {
        super();
        this.viewNavigator = viewNavigator;
        this.dataContext = viewModelCollection_1.getAddNewSongViewModel();
        this.dataContext.title = "Add New Song";
        this.dataContext.formData.main = {};
        let mainElement = document.createElement("main");
        mainElement.classList.add("main");
        let html = new HtmlWidget_1.HtmlWidget("form", "");
        html.renderBody.autocomplete = "off";
        html.renderBody.classList.add("form-center");
        let accordion = new AccordionWidget_1.AccordionWidget();
        html.widgets.push(accordion);
        accordion.accordionAdded = (section) => this.dataContext.accordionSections.push(section);
        let importJsonPanel = accordion.addAccordionSection("Import Song From JSON", false, null).panel;
        let importJsonForm = new HTMLWidgetFormBuilder_1.HtmlWidgetFormBuilder(importJsonPanel);
        let browseModalDialog = new BrowseResourceModalDialogBox_1.BrowseResourceModalDialogBox(this.dataContext.resourceManager, html.renderBody);
        importJsonForm.addParagraph("You have the ability to import a song from a JSON file.")
            .addFileInput("JSON File", "jsonFileInput", false, fileInput => {
            fileInput.accept = ".json";
        })
            .addElement("button", button => {
            button.classList.add("btn", "btn-submit");
            button.textContent = "Import";
            button.addEventListener("click", () => {
                let jsonFileInput = document.querySelector("#jsonFileInput");
                if (jsonFileInput.files.length === 0) {
                    alert("Please select a file.");
                    return;
                }
                let file = jsonFileInput.files[0];
                let fileReader = new FileReader();
                fileReader.onload = (evt) => __awaiter(this, void 0, void 0, function* () {
                    let newSongId = yield this.dataContext.importSongAndClear(fileReader.result.toString());
                    alert("Song Imported!");
                    viewNavigator.navigate("MusicDetails", { songId: newSongId });
                });
                fileReader.readAsText(file);
            });
        });
        let formPanel = accordion.addAccordionSection("New Song", false, null).panel;
        let formBuilder = new HTMLWidgetFormBuilder_1.HtmlWidgetFormBuilder(formPanel);
        formBuilder.addTextInput("Song Name", "songNameInput", true)
            .addTextInput("Artist", "artistInput", true)
            .addUrlInput("URL To Song Image", "songImageInput", false)
            .addElement("div", div => {
            div.classList.add("admon-warning");
            div.textContent =
                "WARNING: the image will be resized to fit the banner width. Any image size is allowed.";
        })
            .addResourceInput("Audio Resource", "urlInput", true, (input) => {
            browseModalDialog.showDialog();
        }, input => {
            browseModalDialog.valueSelected = (type, resourceId, name) => {
                this.dataContext.formData.main.audioResourceId = resourceId;
                input.value = `${Resource_1.ResourceType[type]}: ${name}`;
            };
        });
        let cardGrid = new CardGridWidget_1.CardGridWidget();
        html.widgets.push(cardGrid);
        this.renderCards(cardGrid, accordion);
        html.createElement("button", element => {
            let button = element;
            button.id = "submit";
            button.classList.add("btn");
            button.classList.add("btn-submit");
            button.type = "button";
            button.textContent = "Add Song";
            button.addEventListener("click", () => __awaiter(this, void 0, void 0, function* () {
                if (!html.renderBody.checkValidity()) {
                    alert("Form not valid.");
                    return;
                }
                this.dataContext.formData.main.songName = html.element.querySelector("div #songNameInput").value;
                this.dataContext.formData.main.artist = html.element.querySelector("div #artistInput").value;
                this.dataContext.formData.main.songImageUrl =
                    html.element.querySelector("div #songImageInput").value;
                this.populateFormData(accordion);
                let newSongId = yield this.dataContext.addSongAndClear();
                alert("Song Added");
                viewNavigator.navigate("MusicDetails", { songId: newSongId });
            }));
        });
        this.renderBody = mainElement;
        this.widgets.push(html);
    }
    populateFormData(accordion) {
        for (let section of this.dataContext.accordionSections) {
            if (section.additionalData != null) {
                let inputs = section.panel.renderBody.querySelectorAll(".row .col-75 .input-search");
                for (let j = 0; j < inputs.length; j++) {
                    let inputElement = inputs[j];
                    this.dataContext.formData[section.additionalData.basePlugin.pluginName][inputElement.id] = inputElement.value;
                }
            }
        }
    }
    addCard(cardGrid, accordionWidget, component, appendChild = false) {
        var _a;
        cardGrid.addCard(component.basePlugin.friendlyPluginName, (_a = component.basePlugin.description) !== null && _a !== void 0 ? _a : "No Description has been provided for this plugin.", appendChild, (card) => {
            let section = accordionWidget.addAccordionSection(component.basePlugin.pluginName, true, component);
            let panel = section.panel;
            panel.createElement("button", button => {
                button.textContent = "Remove";
                button.classList.add("btn");
                button.addEventListener("click", () => {
                    accordionWidget.removeAccordionSection(panel);
                    this.dataContext.accordionSections.splice(this.dataContext.accordionSections.indexOf(section), 1);
                    this.dataContext.pluginsUsed.splice(this.dataContext.pluginsUsed.indexOf(component), 1);
                    this.dataContext.formData[component.basePlugin.pluginName] = null;
                    this.addCard(cardGrid, accordionWidget, component, true);
                });
            });
            component.addForm(new HTMLWidgetFormBuilder_1.HtmlWidgetFormBuilder(panel, true));
            this.dataContext.formData[component.basePlugin.pluginName] = {};
            this.dataContext.pluginsUsed.push(component);
            cardGrid.renderBody.removeChild(card);
        });
    }
    renderCards(cardGrid, accordionDiv) {
        for (let component of this.dataContext.supportedPluginComponents) {
            this.addCard(cardGrid, accordionDiv, component);
        }
    }
    shouldRender() {
        return true;
    }
}
exports.AddNewSongView = AddNewSongView;
//# sourceMappingURL=AddNewSongView.js.map